import { momentModule } from '../vendor/moment';

export const durationFormatFilterModule = angular
  .module('Q.filters.duration-format', [momentModule])
  .filter('durationFormat', function (moment) {
    return function durationFormat(value, format, lowercase) {
      if (value === null || isNaN(value)) {
        return '';
      }

      const d = moment.duration(value, format);
      const days = d.days();
      const hours = d.hours();
      const minutes = d.minutes();
      const seconds = d.seconds();

      const parts = [];

      const push = (amt, unit) => {
        if (!amt || amt <= 0) return;

        parts.push(amt);
        let u = lowercase ? unit.toLowerCase() : unit;
        if (amt !== 1) {
          u += 's';
        }
        parts.push(u);
      };

      push(days, 'Day');
      push(hours, 'Hour');
      push(minutes, 'Minute');
      push(seconds, 'Second');
      return parts.join(' ');
    };
  });
